"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSBBMySearchFilterComponent = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const core_1 = require("@angular/core");
const account_service_1 = require("../../shared/services/account.service");
const index_1 = require("../../shared/index");
const roles_helper_service_1 = require("../../shared/services/roles-helper.service");
const _ = require("underscore");
const router_1 = require("@angular/router");
const searchfilter_pipe_1 = require("../pipes/searchfilter.pipe");
const orderBy_pipe_1 = require("../pipes/orderBy.pipe");
const ng_bootstrap_1 = require("@ng-bootstrap/ng-bootstrap");
const insurance_service_1 = require("../../insurancesection/services/insurance.service");
const interfaces_component_1 = require("../../insurancesection/interfaces/interfaces.component");
const XLSX = require("xlsx");
const constants_1 = require("../../shared/constants");
class CSBBMySearchFilterComponent {
    constructor(helperService, route, accountService, modalService, insuranceService, rolesService, router) {
        this.helperService = helperService;
        this.route = route;
        this.accountService = accountService;
        this.modalService = modalService;
        this.insuranceService = insuranceService;
        this.rolesService = rolesService;
        this.router = router;
        this.sortFilterArray = ['1-10', '20', '50', '100'];
        this.openedSubList = [];
        this.selectedSortNumber = '1-10';
        this.pager = {};
        this.alive = true;
        this.isDesc = false;
        this.IsuranceTypeEnum = interfaces_component_1.InsuranceType;
        this.InsuranceTypeEnumNames = interfaces_component_1.InsuranceTypeNames;
        this.arrExcelData = [];
        this.dataPriorityFeatureId = 'MS_GOV_DATA_PRIORITY';
        this.profileSubscriptionIdList = {};
        this.isProfileExpanded = false;
        this.isDivisionExpanded = false;
        this.isDepartmentExpanded = false;
        this.isPhoneExpanded = false;
        this.isStatusExpanded = false;
        this.areChipsExpanded = false;
        this.activeChips = [];
        this.underscoreRegex = /_/g;
        // Limit chips to 2 so they stay in single row; extras show as '+N'
        this.maxChips = 2;
        this.maxLimitReached = new core_1.EventEmitter();
        this.subscription = new core_1.EventEmitter();
        this.subscriptionsList = new core_1.EventEmitter();
        this.bulkOperationList = new core_1.EventEmitter();
        this.isAnySubSelected = new core_1.EventEmitter();
        this.filteredSubId = new core_1.EventEmitter();
        this.selectedSubIds = new core_1.EventEmitter();
        this.roles = constants_1.UserRole;
        this.selectDepartmentTemp = 'Department';
        this.selectPhoneTemp = 'Phone';
        this.selectPlanTemp = 'Plan';
        this.selectDivisionTemp = 'Division';
        this.selectStatusTemp = 'Status';
        this.selectFeatureTemp = 'Feature';
        this.selectProfileTemp = 'yes';
        this.selectSortCol = 'Sort By';
    }
    ngOnInit() {
        this.MEID_HEX = 14;
        this.MEID_HEX_W_CD = 15;
        this.MEID_DEC = 18;
        this.MEID_DEC_W_CD = 19;
        this.upgradeContent = 'Upgrade This Device';
        this.isViewDetails = false;
        this.subLinesLoader = false;
        this.hasProfile = false;
        if (this.route !== null && this.route !== undefined) {
            this.route.queryParams.subscribe((params) => {
                const subId = params['subId'];
                this.selectedSubId = subId;
                this.viewLineDetail(subId);
                this.isViewDetails = true;
                const sub = _.where(this.subscriptions, { 'subscriptionId': subId });
                const mobNumber = _.pluck(sub, 'mobileNumber');
                this.tmpMobNumber = mobNumber[0];
            });
        }
        const landscape = (window.orientation === 0 || window.orientation === 180);
        if (window.screen.width <= 768 && landscape) { // 768px portrait // 768px portrait
            this.ismobile = true;
        }
        else {
            this.ismobile = false;
        }
        this.prepareHeaderList();
        if (this.isProfileComponent) {
            this.roleFilters = this.getDistinctRoleFilters(this.filteredSubscriptions);
            this.selectProfileTemp = 'Profile';
        }
    }
    prepareHeaderList() {
        this.headerMap = new Map();
        this.headerMap.set('NAME/ASSET #', 'subscriberBusinessName');
        this.headerMap.set('MOBILE #', 'mobileNumber');
        if (!this.isPlansComponent) {
            this.headerMap.set('DEVICE NAME', 'deviceName');
        }
        this.headerMap.set('PLAN NAME', 'planDisplayName');
        this.headerMap.set('DIVISION', 'divisionName');
        this.headerMap.set('DEPARTMENT', 'departmentName');
        this.headerMap.set('START DATE', 'startCal');
        this.headerMap.set('END DATE', 'endCal');
        this.headerMap.set('STATUS', 'subscriptionStatus');
    }
    getKeys() {
        return Array.from(this.headerMap.keys());
    }
    ngOnChanges(changes) {
        if (changes['subscriptions']) {
            if (!_.isEmpty(this.subscriptions)) {
                this.filteredSubscriptions = _.clone(this.subscriptions);
                this.setPage(1, 10);
                this.tmpSubs = _.clone(this.subscriptions);
                if (!this.isProfileComponent) {
                    this.mmaProfileCheck();
                }
            }
        }
        if (changes['updatedSubscription']) {
            // Update ACS-related data which controls the alert
            if (this.subscriptions != null && this.updatedSubscription != null) {
                const updatedSubscriptionIndex = this.subscriptions.findIndex((element) => element.subscriptionId === this.updatedSubscription.subscriptionId);
                if (updatedSubscriptionIndex != null) {
                    this.subscriptions[updatedSubscriptionIndex].acsCounter = this.updatedSubscription.acsCounter;
                    this.subscriptions[updatedSubscriptionIndex].insuranceActive = this.updatedSubscription.insuranceActive;
                    this.subscriptions[updatedSubscriptionIndex].insuranceType = this.updatedSubscription.insuranceType;
                    this.subscriptions[updatedSubscriptionIndex].acsEligible = this.updatedSubscription.acsEligible;
                }
            }
        }
        if (this.isProfileComponent) {
            this.updateActiveChips();
        }
    }
    ngAfterViewChecked() {
        if (this.accountData) {
            setTimeout(() => {
                this.filteredSubscriptions = _.clone(this.subscriptions);
                this.setPage(1, 10);
                this.tmpSubs = _.clone(this.subscriptions);
                this.accountData = false;
                if (!this.isProfileComponent) {
                    this.mmaProfileCheck();
                }
                if (this.tmpMobNumber) {
                    this.searchQuery = this.tmpMobNumber;
                    this.onInputSearchChange(this.searchQuery);
                }
            }, 100);
        }
    }
    ngAfterContentInit() {
        if (_.isEmpty(this.subscriptions) || this.subscriptions === undefined) {
            this.subLinesLoader = true;
            this.runAccountWSDLStatusTimer();
        }
        setTimeout(() => {
            this.searchQuery = this.tmpMobNumber;
            this.onInputSearchChange(this.searchQuery);
        }, 300);
    }
    mmaProfileCheck() {
        setTimeout(() => {
            if (this.isProfileCheck) {
                this.applyProfile = 'yes';
                this.selectProfileTemp = 'yes';
                this.applyFilter();
            }
            else {
                this.applyProfile = 'no';
                this.selectProfileTemp = 'no';
                this.applyFilter();
            }
        }, 300);
    }
    editProfile(event, subscriptionId) {
        this.router.navigate(['/business/profile'], { queryParams: { subId: subscriptionId, permission: 'edit' } });
    }
    onInputSearchChange(searchTextQuery) {
        this.isValidAppleSerialNo = false;
        if (this.validateAppleSerialNo(searchTextQuery)) {
            this.isValidAppleSerialNo = true;
        }
        else if (searchTextQuery !== undefined && searchTextQuery.length === this.MEID_HEX_W_CD) {
            searchTextQuery = this.removeCheckDigit(searchTextQuery, this.MEID_HEX);
        }
        else if (searchTextQuery !== undefined && searchTextQuery.length === this.MEID_DEC_W_CD) {
            searchTextQuery = this.removeCheckDigit(searchTextQuery, this.MEID_DEC);
        }
        this.isFilter = false;
        this.isSearch = true;
        // const tempVar = searchTextQuery;
        if (!_.isEmpty(searchTextQuery)) {
            // handle the scenario when dashes are present in Name field
            searchTextQuery = searchTextQuery.replace(/\(|\)|-| /g, '');
        }
        switch (searchTextQuery) {
            case 'Department':
            case 'Phone':
            case 'Plan':
            default:
                this.searchText = searchTextQuery;
                break;
        }
        const searchPipe = new searchfilter_pipe_1.SearchFilterPipe();
        if (!this.isValidAppleSerialNo) {
            if (this.isUpgradeComponent) {
                // eslint-disable-next-line max-len
                this.filteredSubscriptions = searchPipe.transform(this.subscriptions, { 'subscriberBusinessName': this.searchText, 'firstName': this.searchText, 'lastName': this.searchText, 'mobileNumber': this.searchText, 'esnMeid': this.searchText, 'isSearchData': this.isSearch }, false);
            }
            else {
                // eslint-disable-next-line max-len
                this.filteredSubscriptions = searchPipe.transform(this.subscriptions, { 'subscriberBusinessName': this.searchText, 'mobileNumber': this.searchText, 'esnMeid': this.searchText, 'modelNumber': this.searchText, 'uiccId': this.searchText, 'isSearchData': this.isSearch }, false);
                if (this.filteredSubscriptions && this.filteredSubscriptions.length === 1) {
                    this.viewLineDetail(this.filteredSubscriptions[0].subscriptionId, 0);
                }
            }
            this.selectedSortNumber = '1-10';
            this.onSelectSort(this.selectedSortNumber);
        }
        else {
            this.getInfoByAppleSerialNo(this.searchText).then((response) => {
                if (response) {
                    if (response.subscriptionInfoList && response.subscriptionInfoList.length > 0) {
                        const esn = response.subscriptionInfoList[0].deviceInfo.esn;
                        // eslint-disable-next-line max-len
                        this.filteredSubscriptions = searchPipe.transform(this.subscriptions, { 'esnMeid': esn, 'isSearchData': this.isSearch }, false);
                        this.selectedSortNumber = '1-10';
                        this.onSelectSort(this.selectedSortNumber);
                    }
                }
            });
        }
    }
    onFocusChange() {
        this.clearFilter();
    }
    clearFilter() {
        this.selectDepartment = '';
        this.selectPhone = '';
        this.selectPlan = '';
        this.applyDepartment = '';
        this.applyPhone = '';
        this.applyPlan = '';
        this.applyDivision = '';
        this.applyStatus = '';
        this.applyProfile = '';
        this.applyFeature = '';
        this.selectDepartmentTemp = 'Department';
        this.selectPhoneTemp = 'Phone';
        this.selectPlanTemp = 'Plan';
        this.selectSortCol = 'Sort By';
        this.selectDivisionTemp = 'Division';
        this.selectStatusTemp = 'Status';
        this.selectProfileTemp = 'Profile';
        this.selectFeatureTemp = 'Feature';
        // assign below variables to null for clear filter to work.
        this.applyDepartment = null;
        this.applyPhone = null;
        this.applyPlan = null;
        this.applyDivision = null;
        this.applyStatus = null;
        this.applyProfile = null;
        this.applyFeature = null;
        this.filteredSubscriptions = _.clone(this.subscriptions);
        this.selectedSortNumber = '1-10';
        if (this.pager !== null && this.pager !== undefined) {
            if (this.pager.currentPage !== 1) {
                this.pager.currentPage = 1;
            }
        }
        this.onSelectSort(this.selectedSortNumber);
        this.resetsearch();
        if (this.isProfileComponent) {
            this.updateActiveChips();
            if (this.isFilterOpen) {
                this.toggleFilterPopover();
            }
        }
    }
    resetsearch() {
        this.searchQuery = '';
        this.onInputSearchChange(this.searchQuery);
    }
    onFilterChange(searchTextQuery, result) {
        this.isFilter = true;
        this.isSearch = false;
        switch (result) {
            case 'Department':
            case 'Phone':
            case 'Plan':
            case 'selectedDepartment':
                this.setDivisionList(searchTextQuery);
                this.applyDepartment = searchTextQuery;
                break;
            case 'selectedPhone':
                this.applyPhone = searchTextQuery;
                break;
            case 'selectedPlan':
                this.applyPlan = searchTextQuery;
                break;
            case 'selectedDivision':
                this.setDepartmentList(searchTextQuery);
                this.applyDivision = searchTextQuery;
                break;
            case 'selectedStatus':
                this.applyStatus = searchTextQuery;
                break;
            case 'selectedFeature':
                this.applyFeature = searchTextQuery;
                break;
            case 'selectedProfile':
                this.applyProfile = searchTextQuery;
                break;
            default:
                break;
        }
    }
    toggleFilterPopover() {
        this.isFilterOpen = !this.isFilterOpen;
        if (!this.isFilterOpen) {
            this.closeExpandedFilters();
            this.showFewerChips();
        }
        else {
            this.showAllChips();
        }
    }
    closeExpandedFilters() {
        this.isProfileExpanded = false;
        this.isDivisionExpanded = false;
        this.isDepartmentExpanded = false;
        this.isPhoneExpanded = false;
        this.isStatusExpanded = false;
    }
    // Method to prepare Department list based on selected Division
    setDepartmentList(divisionName) {
        if (this.subscriptions !== null && this.subscriptions !== undefined && this.subscriptions.length > 0) {
            if (divisionName !== 'Division') {
                this.departments = [];
                this.subscriptions.forEach((element) => {
                    if (element.divisionName === divisionName) {
                        if ((element.departmentName !== undefined) && !(this.departments.indexOf(element.departmentName) > -1)) {
                            this.departments.push(element.departmentName);
                        }
                    }
                });
            }
            else {
                this.departments = _.uniq((_.pluck(this.subscriptions, 'departmentName')));
                this.departments = this.departments.filter(function (element) {
                    return element !== undefined;
                });
            }
        }
    }
    // Method to prepare Division list based on selected Department
    setDivisionList(departmentName) {
        if (this.subscriptions !== null && this.subscriptions !== undefined && this.subscriptions.length > 0) {
            if (departmentName !== 'Department') {
                this.divisions = [];
                this.subscriptions.forEach((element) => {
                    if (element.departmentName === departmentName) {
                        if ((element.divisionName !== undefined) && !(this.divisions.indexOf(element.divisionName) > -1)) {
                            this.divisions.push(element.divisionName);
                        }
                    }
                });
            }
            else {
                this.divisions = _.uniq(_.pluck(this.subscriptions, 'divisionName'));
                this.divisions = this.divisions.filter(function (element) {
                    return element !== undefined;
                });
            }
        }
    }
    applyFilter() {
        // if variables are null then we have to assign to undefined for the filter to work
        if (this.applyDepartment === null || this.applyDepartment === 'Department') {
            this.applyDepartment = undefined;
        }
        if (this.applyPhone === null || this.applyPhone === 'Phone') {
            this.applyPhone = undefined;
        }
        if (this.applyPlan === null || this.applyPlan === 'Plan') {
            this.applyPlan = undefined;
        }
        if (this.applyDivision === null || this.applyDivision === 'Division') {
            this.applyDivision = undefined;
        }
        if (this.applyStatus === null || this.applyStatus === 'Status') {
            this.applyStatus = undefined;
        }
        if (this.applyProfile === null || this.applyProfile === 'Profile') {
            this.applyProfile = undefined;
        }
        if (this.applyFeature === null || this.applyFeature === 'Feature') {
            this.applyFeature = undefined;
        }
        const filterPipe = new index_1.DropdownFilterPipe();
        if (this.applyPhone !== null && this.applyPhone !== undefined) {
            this.phoneName = this.applyPhone.replace(/[&\/\\#,+()$~%.'":*?<>{}-]/g, '');
        }
        else {
            this.phoneName = undefined;
        }
        if (this.isUpgradeComponent) {
            // eslint-disable-next-line max-len
            this.filteredSubscriptions = filterPipe.transform(this.subscriptions, { 'departmentName': this.applyDepartment, 'deviceDisplayName': this.phoneName, 'planDisplayName': this.applyPlan, 'features.featureDisplayName': this.applyFeature, 'divisionName': this.applyDivision, 'subscriptionStatus': this.applyStatus }, true, this.dataPriorityFeatureId);
        }
        else if (this.isInsuranceComponent) {
            // eslint-disable-next-line max-len
            this.filteredSubscriptions = filterPipe.transform(this.subscriptions, { 'departmentName': this.applyDepartment, 'device.displayName': this.phoneName }, true, this.dataPriorityFeatureId);
        }
        else if (this.isProfileComponent) {
            // eslint-disable-next-line max-len
            this.filteredSubscriptions = filterPipe.transform(this.subscriptions, { 'departmentName': this.applyDepartment, 'fullDeviceName': this.phoneName, 'plan.planDisplayName': this.applyPlan, 'features.featureDisplayName': this.applyFeature, 'divisionName': this.applyDivision, 'profileRole': this.applyProfile, 'subscriptionStatus': this.applyStatus }, true, this.dataPriorityFeatureId);
        }
        else if (this.isDataPriorityFeaturePresent && this.applyFeature) {
            // eslint-disable-next-line max-len
            this.filteredSubscriptions = filterPipe.transform(this.subscriptions, { 'departmentName': this.applyDepartment, 'device.displayName': this.phoneName, 'plan.planDisplayName': this.applyPlan, 'features.featureDisplayName': this.applyFeature, 'divisionName': this.applyDivision, 'subscriptionStatus': this.applyStatus }, true, this.dataPriorityFeatureId);
        }
        else {
            // eslint-disable-next-line max-len
            this.filteredSubscriptions = filterPipe.transform(this.subscriptions, { 'departmentName': this.applyDepartment, 'device.displayName': this.phoneName, 'plan.planDisplayName': this.applyPlan, 'features.featureDisplayName': this.applyFeature, 'divisionName': this.applyDivision, 'subscriptionStatus': this.applyStatus }, true, this.dataPriorityFeatureId);
        }
        this.selectDepartment = this.applyDepartment;
        this.selectPhone = this.applyPhone;
        this.selectPlan = this.applyPlan;
        this.selectDivision = this.applyDivision;
        this.selectStatus = this.applyStatus;
        this.selectProfile = this.applyProfile;
        this.selectFeature = this.applyFeature;
        this.selectedSortNumber = '1-10';
        this.onSelectSort(this.selectedSortNumber);
        this.searchQuery = '';
        if (this.isProfileComponent) {
            this.isFilterOpen = false;
            this.updateActiveChips();
        }
        this.selectProfileTemp = this.applyProfile ? this.applyProfile : 'Profile';
        this.selectDivisionTemp = this.applyDivision ? this.applyDivision : 'Division';
        this.selectDepartmentTemp = this.applyDepartment ? this.applyDepartment : 'Department';
        this.selectPhoneTemp = this.applyPhone ? this.applyPhone : 'Phone';
        this.selectStatusTemp = this.applyStatus ? this.applyStatus : 'Status';
    }
    clearSingleFilter(filter) {
        this[filter] = null;
        this.applyFilter();
    }
    toggleFilter(filter) {
        switch (filter) {
            case 'profile':
                this.isProfileExpanded = !this.isProfileExpanded;
                break;
            case 'division':
                this.isDivisionExpanded = !this.isDivisionExpanded;
                break;
            case 'department':
                this.isDepartmentExpanded = !this.isDepartmentExpanded;
                break;
            case 'phone':
                this.isPhoneExpanded = !this.isPhoneExpanded;
                break;
            case 'status':
                this.isStatusExpanded = !this.isStatusExpanded;
                break;
            default:
                break;
        }
    }
    onSelectProfile(value) {
        this.selectProfileTemp = value;
        this.onFilterChange(this.selectProfileTemp, 'selectedProfile');
        this.isProfileExpanded = false;
    }
    onSelectDivision(division) {
        this.selectDivisionTemp = division;
        this.onFilterChange(this.selectDivisionTemp, 'selectedDivision');
        this.isDivisionExpanded = false;
    }
    onSelectDepartment(department) {
        this.selectDepartmentTemp = department;
        this.onFilterChange(this.selectDepartmentTemp, 'selectedDepartment');
        this.isDepartmentExpanded = false;
    }
    onSelectPhone(device) {
        this.selectPhoneTemp = device;
        this.onFilterChange(this.selectPhoneTemp, 'selectedPhone');
        this.isPhoneExpanded = false;
    }
    onSelectStatus(subStatus) {
        this.selectStatusTemp = subStatus;
        this.onFilterChange(this.selectStatusTemp, 'selectedStatus');
        this.isStatusExpanded = false;
    }
    updateActiveChips() {
        const chipConfig = [
            {
                category: 'Profile:',
                applied: this.applyProfile,
                tempValue: this.selectProfileTemp,
                clearFn: () => this.clearSingleFilter('applyProfile')
            },
            {
                category: 'Division:',
                applied: this.applyDivision,
                tempValue: this.selectDivisionTemp,
                clearFn: () => this.clearSingleFilter('applyDivision')
            },
            {
                category: 'Department:',
                applied: this.applyDepartment,
                tempValue: this.selectDepartmentTemp,
                clearFn: () => this.clearSingleFilter('applyDepartment')
            },
            {
                category: 'Phone:',
                applied: this.applyPhone,
                tempValue: this.selectPhoneTemp,
                clearFn: () => this.clearSingleFilter('applyPhone')
            },
            {
                category: 'Status:',
                applied: this.applyStatus,
                tempValue: this.selectStatusTemp,
                clearFn: () => this.clearSingleFilter('applyStatus')
            }
        ];
        const chips = chipConfig
            .filter((config) => config.applied)
            .map((config) => ({
            category: config.category,
            selected: config.tempValue,
            clearFn: () => {
                config.clearFn();
                this.updateActiveChips();
                this.areChipsExpanded = this.activeChips.length > this.maxChips;
            }
        }));
        this.activeChips = chips;
        this.areChipsExpanded = this.activeChips.length > this.maxChips;
    }
    showAllChips() {
        this.areChipsExpanded = true;
    }
    showFewerChips() {
        this.areChipsExpanded = false;
    }
    getPillClass(role) {
        switch (role) {
            case 'Account Primary':
                return 'account-primary';
            case 'Admin':
                return 'admin';
            case 'Bill Viewer':
                return 'bill-viewer';
            case 'IT Support':
                return 'it-support';
            default:
                return 'unassigned';
        }
    }
    viewLineDetail(subId, index) {
        if (subId) {
            if (_.isEmpty(this.profileSubscriptionIdList) || this.profileSubscriptionIdList[subId] === undefined) {
                this.profileSubscriptionIdList[subId] = { count: 1 };
            }
            else {
                this.profileSubscriptionIdList[subId].count += 1;
            }
            this.subscription.emit(subId);
            this.selectedSubIds.emit(this.profileSubscriptionIdList);
        }
    }
    closeLineDetail(subId, index) {
        this.subscription.emit(0);
    }
    setPage(page, pageSize) {
        if (this.pager.totalPages !== 0) {
            if (page < 1 || page > this.pager.totalPages) {
                return;
            }
        }
        if (pageSize === '1-10') {
            pageSize = 10;
        }
        else if (pageSize === '20') {
            pageSize = 20;
        }
        else if (pageSize === '50') {
            pageSize = 50;
        }
        else if (pageSize === '100') {
            pageSize = 100;
        }
        // get pager object from service
        if (this.filteredSubscriptions !== null && this.filteredSubscriptions !== undefined
            && page !== undefined) {
            this.pager = this.helperService.getPager(this.filteredSubscriptions.length, page, pageSize);
            this.startIndex = this.pager.startIndex;
            this.endIndex = this.pager.endIndex + 1;
        }
        // get current page of items
        if (this.isInsuranceComponent && this.pager.startIndex !== undefined && this.pager.endIndex !== undefined) {
            this.filteredList = this.filteredSubscriptions.slice(this.pager.startIndex, this.pager.endIndex + 1);
            const SubIdList = _.pluck(this.filteredList, 'subscriptionId');
            this.filteredSubId.emit(SubIdList);
        }
    }
    onSelectSort(selectNumber) {
        this.setPage(1, selectNumber);
        if (selectNumber === '1-10') {
            this.sortNumber = 10;
        }
        else if (selectNumber === '20') {
            this.sortNumber = 20;
        }
        else if (selectNumber === '50') {
            this.sortNumber = 50;
        }
        else if (selectNumber === '100') {
            this.sortNumber = 100;
        }
        this.setPage(this.pager.currentPage, this.sortNumber);
    }
    emitBulkOperationList(sub, event) {
        this.removeBulkOperation();
        this.checkIfMaxLimitReached(sub, event);
        this.bulkOperationList.emit(this.subscriptions);
    }
    selEmitBulkOperationList(sub, event) {
        sub.selected = !sub.selected;
        this.removeBulkOperation();
        this.checkIfMaxLimitReached(sub, event);
        this.bulkOperationList.emit(this.subscriptions);
    }
    checkIfMaxLimitReached(sub, event) {
        let selectedSub;
        // eslint-disable-next-line prefer-const
        selectedSub = _.findWhere(this.subscriptions, { subscriptionId: sub.subscriptionId });
        const checkIfMaxAreSelected = _.where(this.subscriptions, { selected: true });
        if (!_.isEmpty(checkIfMaxAreSelected) && _.size(checkIfMaxAreSelected) > 20) {
            event.target.checked = false;
            sub.selected = false;
            selectedSub.selected = false;
            this.disableUncheckedCheckBox = true;
            this.disabledSubId = sub.subscriptionId;
            this.maxLimitReached.emit(true);
            this.open(this.maxlimitErrMessage);
        }
        else {
            sub.disableUncheckedCheckBox = false;
            this.disabledSubId = null;
            this.disableUncheckedCheckBox = false;
            this.maxLimitReached.emit(false);
        }
    }
    open(content) {
        this.modalRef = this.modalService.open(content, { size: 'lg', windowClass: 'dark-modal', centered: true });
    }
    removeBulkOperation() {
        const checkIfNoneAreSelected = _.findWhere(this.subscriptions, { selected: true });
        if (_.isEmpty(checkIfNoneAreSelected)) {
            this.isAnySubSelected.emit(false);
        }
        else {
            this.isAnySubSelected.emit(true);
        }
    }
    showDetails(subscriptionId) {
        this.router.navigate(['/business/device'], { queryParams: { subId: subscriptionId } });
    }
    splitString(name) {
        const firstName = name.split(' ').slice(0, -1).join(' ');
        const lastName = name.split(' ').slice(-1).join(' ');
        const singleChar = lastName.substring(0, 1);
        return firstName + ' ' + singleChar;
    }
    runAccountWSDLStatusTimer() {
        this.accountWSDLTimer = rxjs_1.timer(0, 10000).pipe(operators_1.takeWhile(() => this.alive)) // only fires when component is alive
            .subscribe(() => {
            this.accountService.getAccountWsdlStatus().subscribe((data) => {
                if (!_.isEmpty(data) && data.status === true) {
                    this.shutDownTimer();
                    this.subLinesLoader = false;
                    this.accountService.getAccountDetails().subscribe((res) => {
                        var _a;
                        if (!this.isUpgradeComponent) {
                            this.subscriptions = res.subscription;
                            const subsList = this.helperService.deepClone(res.subscription);
                            const that = this;
                            _.each(subsList, function (key, value) {
                                subsList[value] = that.helperService.flattenObject(subsList[value]);
                            });
                            if (!_.isEmpty(this.subscriptions)) {
                                this.filteredSubscriptions = _.clone(this.subscriptions);
                                this.setPage(1, 10);
                                this.tmpSubs = _.clone(this.subscriptions);
                            }
                            this.devices = _.uniq(_.pluck(subsList, 'displayName'));
                            this.departments = _.uniq((_.pluck(subsList, 'departmentName')));
                            this.departments = this.departments.filter(function (element) {
                                return element !== undefined;
                            });
                            this.plans = _.uniq(_.pluck(subsList, 'planDisplayName'));
                            this.divisions = _.uniq(_.pluck(subsList, 'divisionName'));
                            this.divisions = this.divisions.filter(function (element) {
                                return element !== undefined;
                            });
                            this.status = _.uniq(_.pluck(subsList, 'subscriptionStatus'));
                            this.status = this.status.filter(function (element) {
                                return element !== undefined;
                            });
                            if (res.dataPriority && !_.isEmpty(this.subscriptions)) {
                                for (const sub of this.subscriptions) {
                                    const feature = (_a = sub === null || sub === void 0 ? void 0 : sub.features) === null || _a === void 0 ? void 0 : _a.filter((objItem) => objItem.featureID === this.dataPriorityFeatureId);
                                    if ((feature === null || feature === void 0 ? void 0 : feature.length) > 0) {
                                        this.isDataPriorityFeaturePresent = true;
                                        break;
                                    }
                                }
                            }
                            this.accountService.emitAccountInfoLoadedSuccess('accountInfoLoadedSuccessfuly');
                        }
                    });
                }
                else {
                    this.subLinesLoader = true;
                }
            }, (err) => {
                this.error = err;
                this.subLinesLoader = false;
            });
        });
    }
    shutDownTimer() {
        this.accountWSDLTimer.unsubscribe();
    }
    ngOnDestroy() {
        this.alive = false; // switches Our IntervalObservable off
    }
    getDistinctRoleFilters(subs) {
        const roleSet = new Set();
        subs.forEach((sub) => {
            if ((sub === null || sub === void 0 ? void 0 : sub.hasProfile) !== 'yes') {
                roleSet.add('No Profile');
            }
            else if ((sub === null || sub === void 0 ? void 0 : sub.roles) && sub.roles.length > 0) {
                sub.roles.forEach((role) => {
                    roleSet.add(role);
                });
            }
            else {
                roleSet.add('Unassigned');
            }
        });
        return Array.from(roleSet);
    }
    removeCheckDigit(inputData, inputLength) {
        return inputData.substring(0, inputLength);
    }
    downloadSubDetails() {
        this.filteredSubscriptions.forEach((sub) => {
            let startDate = '-';
            let endDate = '-';
            if (sub.currentContract) {
                if (sub.currentContract.startDatePrettyFormat && sub.currentContract.startDatePrettyFormat.trim().length !== 0) {
                    startDate = sub.currentContract.startDatePrettyFormat.replace(',', '.');
                }
                if (sub.currentContract.endDatePrettyFormat && sub.currentContract.endDatePrettyFormat.trim().length !== 0) {
                    endDate = sub.currentContract.endDatePrettyFormat.replace(',', '.');
                }
            }
            if (this.isInsuranceComponent) {
                this.arrExcelData.push({
                    'Sub Business Name': sub.subscriptionStatus === 'VOLUNTARY_SUSPEND' ? sub.subscriberBusinessName + '*' : sub.subscriberBusinessName,
                    'Mobile number': sub.mobileNumber,
                    'ESN(MEID)': '\'' + sub.esnMeid + '\'',
                    'Rate Plan Display Name': sub.plan.planDisplayName,
                    'Device': sub.device.deviceName,
                    'Item Name': sub.device.displayName,
                    'Item CSN': sub.device.modelNumber,
                    'POC Start Date': startDate,
                    'POC End Date': endDate
                });
            }
            else {
                this.arrExcelData.push({
                    'Sub Business Name': sub.subscriptionStatus === 'VOLUNTARY_SUSPEND' ? sub.subscriberBusinessName + '*' : sub.subscriberBusinessName,
                    'Mobile number': sub.mobileNumber,
                    'Division': sub.divisionName !== undefined ? sub.divisionName : '-',
                    'Department': sub.departmentName !== undefined ? sub.departmentName : '-',
                    'ESN(MEID)': '\'' + sub.esnMeid + '\'',
                    'Rate Plan Display Name': sub.plan.planDisplayName,
                    'Device': sub.device.deviceName,
                    'Item Name': sub.device.displayName,
                    'POC Start Date': startDate,
                    'POC End Date': endDate,
                    'Status': sub.subscriptionStatus
                });
            }
        });
        const ws = XLSX.utils.json_to_sheet(this.arrExcelData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'sub_details');
        XLSX.writeFile(wb, 'sub_details.xlsx');
    }
    sort(property) {
        this.isDesc = !this.isDesc; // change the direction
        this.column = property;
        this.direction = this.isDesc ? 1 : -1;
        const orderPipe = new orderBy_pipe_1.OrderByPipe();
        this.filteredSubscriptions = orderPipe.transform(this.filteredSubscriptions, { 'property': this.column, 'direction': this.direction });
    }
    manageUser(sub) {
        this.selectedSub = sub;
        const navigationExtras = {
            queryParams: {
                permission: 'edit'
            }
        };
        if (this.selectedSub.subscriptionId) {
            navigationExtras.queryParams.subId = this.selectedSub.subscriptionId;
        }
        if (this.selectedSub.adminProfileId && this.selectedSub.adminProfileId.length > 0) {
            navigationExtras.queryParams.adminProfileId = this.selectedSub.adminProfileId;
        }
        this.router.navigate(['/business/profile'], navigationExtras);
    }
    validateAppleSerialNo(serialNo) {
        if (serialNo) {
            const pattern = new RegExp('^(?=.*[a-zA-Z])(?=.*[0-9])[a-zA-Z0-9]+$');
            return (serialNo.length === 12 && pattern.test(serialNo));
        }
        return false;
    }
    getInfoByAppleSerialNo(serialNo) {
        const promise = new Promise((resolve, reject) => {
            this.accountService.getDeviceInfo('vendorSerialNumber', serialNo).subscribe((result) => {
                resolve(result);
            });
        });
        return promise;
    }
    showRoles(roles) {
        return this.rolesService.getRolesPermission(roles);
    }
}
exports.CSBBMySearchFilterComponent = CSBBMySearchFilterComponent;
//# sourceMappingURL=search-filter-pagination.component.js.map